module.exports = __webpack_public_path__ + "static/P1-68a9a02fe7d376698c3a74c8141abbf1.jpeg";